module.exports = __webpack_public_path__ + "4a0fe56a4d8715a52525b6869cdfc473.woff";